module.exports = __webpack_public_path__ + "static/media/success(12) (Custom).3494e8a6.png";